import { render } from "./FormEditarPublicidade.vue?vue&type=template&id=003265d6&scoped=true"
import script from "./FormEditarPublicidade.vue?vue&type=script&lang=js"
export * from "./FormEditarPublicidade.vue?vue&type=script&lang=js"

import "./FormEditarPublicidade.vue?vue&type=style&index=0&id=003265d6&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003265d6"]])

export default __exports__